/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Message_DescriptionInputs */

const en_admin_questionnaire_editor_message_description = /** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members will be prompted to fill in these questions when they sign up. You can add additional questions on each plan.`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const de_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const es_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const it_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Message_DescriptionInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_message_description = en_admin_questionnaire_editor_message_description;

/**
* | output |
* | --- |
* | "Members will be prompted to fill in these questions when they sign up. You can add additional questions on each plan." |
*
* @param {Admin_Questionnaire_Editor_Message_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_message_description = /** @type {((inputs?: Admin_Questionnaire_Editor_Message_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Message_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_message_description(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_message_description(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_message_description(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_message_description(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_message_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_message_description(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_message_description(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_message_description(inputs)
	return ro_admin_questionnaire_editor_message_description(inputs)
});
export { admin_questionnaire_editor_message_description as "admin.questionnaire_editor.message_description" }